A profile of a position opening.

This contains information of how a position opening is presented as an internal requisition.
